var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"hover-target",on:{"mouseover":_vm.showTooltip,"mouseleave":_vm.hideTooltip}},[_vm._v(" 悬停我 "),(_vm.isTooltipVisible)?_c('div',{staticClass:"tooltip"},[_vm._v(" 这是悬浮框内容 ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }